import { render, staticRenderFns } from "./Wp_jd_pay_data.vue?vue&type=template&id=00a5fbde&scoped=true&"
import script from "./Wp_jd_pay_data.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_pay_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5fbde",
  null
  
)

export default component.exports